import { render } from "./OrderStatistics.vue?vue&type=template&id=5024cac5&scoped=true"
import script from "./OrderStatistics.vue?vue&type=script&lang=js"
export * from "./OrderStatistics.vue?vue&type=script&lang=js"

import "./OrderStatistics.vue?vue&type=style&index=0&id=5024cac5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5024cac5"]])

export default __exports__